'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconNode", "text", "_bodyElement", "hideTooltip", "maxTooltipWidth", "useOnDark", "maxChars"];
import { Component } from 'react';
import UIMoveableObject from 'UIComponents/draggable/UIMoveableObject';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIIcon from 'UIComponents/icon/UIIcon';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { OBSIDIAN, EERIE, OLAF, CIRRUS } from 'HubStyleTokens/colors';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "EPAddableObject__Wrapper",
  componentId: "sc-1btt4ty-0"
})([".hs-private.hs-private.hs-private &{color:", ";font-size:12px;font-weight:400;}.hs-private.hs-private.hs-private & p{margin-bottom:0;}"], OBSIDIAN);
const IconWrapper = styled.div.withConfig({
  displayName: "EPAddableObject__IconWrapper",
  componentId: "sc-1btt4ty-1"
})([".hs-private.hs-private.hs-private &{font-size:20px;}"]);
const styles = useOnDark => ({
  backgroundColor: useOnDark ? OLAF : CIRRUS,
  color: EERIE
});
const DEFAULT_MAX_CHARS = 38;
class EPAddableObject extends Component {
  render() {
    const _this$props = this.props,
      {
        iconNode,
        text,
        _bodyElement,
        hideTooltip,
        maxTooltipWidth,
        useOnDark,
        maxChars
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const icon = iconNode || /*#__PURE__*/_jsx(UIIcon, {
      size: 20,
      color: EERIE,
      name: 'customModules'
    });
    const disableTooltip = hideTooltip || text && text.length <= maxChars;
    return /*#__PURE__*/_jsx(UIMoveableObject, Object.assign({
      closeable: false,
      style: styles(useOnDark),
      truncate: false
    }, rest, {
      children: /*#__PURE__*/_jsx(UIMediaObject, {
        align: "center",
        itemLeft: /*#__PURE__*/_jsx(IconWrapper, {
          children: icon
        }),
        children: /*#__PURE__*/_jsx(UITooltip, {
          title: text,
          autoPlacement: false,
          placement: 'bottom',
          maxWidth: maxTooltipWidth,
          _bodyElement: _bodyElement,
          delay: 0,
          disabled: disableTooltip,
          children: /*#__PURE__*/_jsx(Wrapper, {
            children: /*#__PURE__*/_jsx(UITruncateMultiline, {
              maxChars: maxChars,
              text: text
            })
          })
        })
      })
    }));
  }
}
EPAddableObject.propTypes = {
  maxTooltipWidth: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  iconNode: PropTypes.node,
  useOnDark: PropTypes.bool.isRequired,
  _bodyElement: PropTypes.object,
  hideTooltip: PropTypes.bool.isRequired,
  maxChars: PropTypes.number.isRequired
};
EPAddableObject.defaultProps = {
  maxTooltipWidth: 200,
  hideTooltip: false,
  useOnDark: false,
  maxChars: DEFAULT_MAX_CHARS
};
export default EPAddableObject;